import { Box, Text } from 'ink';
import { useEffect, useState } from 'react';
import { Build } from '@todesktop/shared';

interface IntrospectionNoticeProps {
  build: Build;
}

export default function IntrospectionNotice({
  build,
}: IntrospectionNoticeProps) {
  const [hasShownNotice, setHasShownNotice] = useState(false);

  useEffect(() => {
    if (hasShownNotice) return;

    const { introspect } = build;
    if (!introspect) return;

    const readyPlatforms = (['mac', 'windows', 'linux'] as const).filter(
      (platform) => {
        const platformData = introspect[platform];
        return (
          platformData?.enabled &&
          (platformData.shellStatus === 'ready' ||
            platformData.shellStatus === 'disconnected')
        );
      },
    );

    if (readyPlatforms.length > 0) {
      setHasShownNotice(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [build.introspect, hasShownNotice]);

  if (!hasShownNotice) {
    return null;
  }

  return (
    <Box flexDirection="column" marginBottom={1}>
      <Text color="green">
        🔎 Introspection tunnel available. Run{' '}
        <Text bold>todesktop introspect {build.id}</Text> in another terminal to
        connect.
      </Text>
    </Box>
  );
}
